import arcaIcon from '../img/svgs/payment/arca.svg';
import visaIcon from '../img/svgs/payment/visa.svg';
import mastercardIcon from '../img/svgs/payment/masterCard3.svg';
import cardIcon from '../img/svgs/payment/card.svg';

const cartTypes = [
  {
    type: 'arca',
    regex: /^9051\d{0,12}/,
    icon: arcaIcon,
  },
  {
    type: 'visa',
    regex: /^4\d{0,15}/,
    icon: visaIcon,
  },
  {
    type: 'mastercard',
    regex: /^(5[1-5]\d{0,2}|22[2-9]\d{0,1}|2[3-7]\d{0,2})\d{0,12}/,
    icon: mastercardIcon,
  },
  {
    type: 'amex',
    regex: /^3[47]\d{0,13}/,
    icon: cardIcon,
  },
  {
    type: 'diners',
    regex: /^3(?:0([0-5]|9)|[689]\d?)\d{0,11}/,
    icon: cardIcon,
  },
  {
    type: 'mir',
    regex: /^220[0-4]\d{0,12}/,
    icon: cardIcon,
  },
  {
    type: 'jcb15',
    regex: /^(?:2131|1800)\d{0,11}/,
    icon: cardIcon,
  },
  {
    type: 'jcb',
    regex: /^(?:35\d{0,2})\d{0,12}/,
    icon: cardIcon,
  },
];

// eslint-disable-next-line import/prefer-default-export
export const getCardIcon = (cardNumber) => {
  // eslint-disable-next-line array-callback-return,consistent-return
  const selectedType = cartTypes.find((type) => {
    if (cardNumber.match(type.regex)) {
      return type;
    }
  });

  return selectedType.icon || cardIcon;
};
